//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"Name",1,0],[0,"UseType",1,0]],[[["numInstances"],"GetInstances",{R_:{instances:""}},0,0],[["instances"],"SetInstances",{},1,0],[["instanceName","magazineNumber","pocketNumber","toolName"],"GetInstanceToolInformation",{},1,1],[["instanceName","magazineNumber","pocketNumber","toolName"],"SetInstanceToolInformation",{},4,1],[["instanceName","channelId","magazineNumber","pocketNumber","toolName"],"GetInstanceToolInformationV2",{},1,0],[["instanceName","channelId","magazineNumber","pocketNumber","toolName"],"SetInstanceToolInformationV2",{},5,0],[["filePathName"],"ExportToFile",{R_:{errorMessage:''}},1,0],[["filePathName"],"ImportFromFile",{R_:{errorMessage:''}},1,0],[["createContainer","containerName"],"GetContainerInformation",{},0,0],[["createContainer","containerName"],"SetContainerInformation",{},2,0]],[]];
SPLM.Mechatronics.DynamicObjectTableBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.DynamicObjectTableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.DynamicObjectTableBuilder.Instance = class{
    constructor(name,tDefiningSnap,tDynamicObject,tComplyingSnap){
        this.name=name;this.tDefiningSnap=tDefiningSnap;this.tDynamicObject=tDynamicObject;this.tComplyingSnap=tComplyingSnap;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Tdefiningsnap(){return this.tDefiningSnap}
    set Tdefiningsnap(val){this.tDefiningSnap = val}
    get Tdynamicobject(){return this.tDynamicObject}
    set Tdynamicobject(val){this.tDynamicObject = val}
    get Tcomplyingsnap(){return this.tComplyingSnap}
    set Tcomplyingsnap(val){this.tComplyingSnap = val}
};

SPLM.Mechatronics.DynamicObjectTableBuilder.UseTypes = Object.freeze({
    "DynamicObjectTable" : "DynamicObjectTable", "SinumerikToolTable" : "SinumerikToolTable"});

export default SPLM;